import TagManager from 'react-gtm-module'

import { roundToTwoDecimals } from '../math'
import { Product } from '../types/Product'
import { getPrices } from '../../lib/getPrices'

const orderRequestManualCheckLimitEvent = (product: Product, totalQuantity: number | string) => {
  const {
    default: { price: defaultUnitPrice, total: defaultTotalPrice },
    final: { price: discountedUnitPrice, total: discountedTotalPrice },
    discount: { current },
  } = getPrices(product, Number(totalQuantity))
  const discountLabel = current?.['price.label'] ?? ''

  TagManager.dataLayer({
    dataLayer: {
      event: 'order_request_manual_check_limit',
      product_id: product['product.code'],
      supplier: product.supplier[0]['supplier.label'],
      discount_label: discountLabel,
      product_quantity: roundToTwoDecimals(totalQuantity),
      total_discount: roundToTwoDecimals(
        current ? defaultTotalPrice - discountedTotalPrice : 0,
      ),
      default_unit_price: roundToTwoDecimals(defaultUnitPrice),
      discounted_unit_price: roundToTwoDecimals(
        current ? discountedUnitPrice : defaultUnitPrice,
      ),
      default_total_price: roundToTwoDecimals(defaultTotalPrice),
      discounted_total_price: roundToTwoDecimals(
        current ? discountedTotalPrice : defaultTotalPrice,
      ),
    },
  })
}

export default orderRequestManualCheckLimitEvent
